import { isOwnedArtifact, type GrantAccess } from "@/lib/grant";
import { Artifact } from "@/types/types";
import {
  faIndustry,
  faLink,
  faProjectDiagram,
} from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { DisplayName } from "./DisplayName";

type ArtifactDisplayNameProps = {
  artifact: Pick<Artifact, "group"> & {
    readonly?: boolean;
    access?: GrantAccess | null;
  };
};

export function ArtifactSourceDisplayName({
  artifact,
}: ArtifactDisplayNameProps) {
  const owned = isOwnedArtifact(artifact);
  const name = owned ? "This Kit" : (artifact.group?.name ?? "Shared");
  const icon = owned ? faProjectDiagram : artifact.group ? faIndustry : faLink;
  return (
    <DisplayName name={name} icon={icon} colorClassName={"text-gray-500"} />
  );
}
